// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"799":"e052b371","811":"94870362","992":"f65cc9cc"}[chunkId] + ".chunk.js";
};